"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockStyleManager = void 0;
var _BlockState = require("./BlockState");
var _style = require("../style");
class BlockStyleManager extends _BlockState.ManagerWithState {
  onClasses(listener) {
    this.events.on("updateClasses", listener);
  }
  offClasses(listener) {
    this.events.off("updateClasses", listener);
  }
  addClass(className) {
    this.spec.classes.push(className);
    this.events.emit("updateClasses", undefined);
  }
  removeClass(className) {
    let index = this.spec.classes.indexOf(className);
    if (index > -1) {
      this.spec.classes.splice(index, 1);
      this.events.emit("updateClasses", undefined);
    }
  }
  getStyleLayers() {
    let layers = [{
      type: "block",
      name: this.type.type
    }];
    let layout = this.state.layoutValue();
    if (layout) {
      layers.push({
        type: "block",
        name: this.type.type,
        layout
      });
    }
    if (this.spec.classes) {
      let classes = this.spec.classes.map(name => {
        return {
          type: "class",
          name
        };
      });
      return [...layers, ...classes];
    }
    return layers;
  }
  classes(layout) {
    let classes = [_style.BlockTypeStyle.className(this.type.type)];
    if (layout) {
      classes.push(_style.BlockTypeStyle.className(this.type.type, layout));
    }
    return [...classes];
  }
}
exports.BlockStyleManager = BlockStyleManager;
//# sourceMappingURL=BlockStyleManager.js.map